import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Language } from '../core/models/language.model';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.css']
})
export class LanguageSelectorComponent implements OnChanges {

  @Input() languages: Language[];

  @Input() locale: string;

  @Output() onLanguageChanged: EventEmitter<Language> = new EventEmitter<Language>();

  selectedLanguage: Language | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    this.selectedLanguage = this.languages.find(language => this.locale === language.getCode());
  }

  onChange(language: Language) {
    this.onLanguageChanged.emit(language);
  }

}
